export class SetLastOpened {
    static readonly type = '[DashboardOverview] Set Last Opened';
    constructor(public lastOpenedIndex: number) {}
}
